import * as projectsService from '../../../../services/Projects/projectsService.js';
import {createDialogActions} from '../../../Dialogs/CommonDialog/commonDialogActions';

export const {
  actionTypes,
  actions,
  api,
  jsxActions,
} = createDialogActions({

  config: {
    getSubmitMethod: ({isEditMode}) =>
      isEditMode  ? projectsService.editProject : projectsService.createProject,
  },
});




// const config = {
//   getSubmitMethod: (submitConfigData) => {
//     return submitConfigData && submitConfigData.isEditMode ?
//       projectsService.editProject : projectsService.createProject;
//   }
// };
//
// export const actionTypes = {
//   ...commonActions.actionTypes,
// };
//
// const actions = {
//   ...commonActions.getActions(),
// };
//
// export let api = {
//   ...commonActions.getApiActions(actions, config),
// }
//
// export let jsxActions = {
//   ...commonActions.getJsxActions(api),
// };

